export default {
  activeFilters: {},
  activeDashboardId: null,
  dashboardConfig: null,
  chartsData: {},
  chartsLoading: {},
  chartsErrors: {},
  indicators: {},
  filterFieldOptions: {}
}
